import { render, staticRenderFns } from "./PlacesSearchRefined.vue?vue&type=template&id=5e2f9544&lang=pug"
import script from "./PlacesSearchRefined.vue?vue&type=script&lang=js"
export * from "./PlacesSearchRefined.vue?vue&type=script&lang=js"
import style0 from "./PlacesSearchRefined.vue?vue&type=style&index=0&id=5e2f9544&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TxtRefined: require('/app/components/vantone/TxtRefined.vue').default})
